import { render } from "./ProfessionalDisplay.vue?vue&type=template&id=6eec032b&scoped=true"
import script from "./ProfessionalDisplay.vue?vue&type=script&lang=ts"
export * from "./ProfessionalDisplay.vue?vue&type=script&lang=ts"

import "./ProfessionalDisplay.vue?vue&type=style&index=0&id=6eec032b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6eec032b"

export default script